import { ParaglideMessage } from '@inlang/paraglide-js-react';
import { Eyebrow } from '../../components/Eyebrow';
import type { Endpoint } from '../../features/catalog/model';
import { m } from '../../paraglide/messages';
import { DrawTable } from './call-order/DrawTable';
import { ProvidersPanel } from './ProvidersPanel';

interface ProvidersSectionProps {
  endpoint: Endpoint;
  /** the platform the heading names, "Instagram" */
  name: string;
}

/** Price and providers. With more than one provider the call-order table draws
 *  itself once on scroll, showing one example call handed from #1 to #2. */
export const ProvidersSection = ({ endpoint, name }: ProvidersSectionProps) => {
  const subject = { name, action: endpoint.action };
  if (endpoint.providers.length <= 1) {
    return (
      <>
        <Eyebrow>{m.endpoint_pricing_eyebrow()}</Eyebrow>
        <h2 className="display-3 mt-4 text-text">{m.endpoint_pricing_heading(subject)}</h2>
        <div className="mt-8">
          <ProvidersPanel key={endpoint.id} providers={endpoint.providers} notServing={endpoint.notServing} />
        </div>
      </>
    );
  }
  const notServing = endpoint.notServing ?? [];
  return (
    <>
      <Eyebrow>{m.endpoint_network_eyebrow()}</Eyebrow>
      <h2 className="display-3 mt-4 text-text">
        {m.endpoint_network_heading({ ...subject, count: endpoint.providers.length })}
      </h2>
      <p className="mt-4 max-w-2xl text-16 text-text-2">{m.endpoint_network_lede()}</p>
      <div className="mt-8">
        <DrawTable key={endpoint.id} providers={endpoint.providers} notServing={notServing} />
      </div>
      {[...endpoint.providers, ...notServing].some((provider) => provider.blockedPct !== undefined) ? (
        <p className="mt-3 max-w-2xl text-13 text-text-3">{m.endpoint_blocked_note()}</p>
      ) : null}
      {notServing.length > 0 ? (
        <p className="mt-3 text-13 text-text-3">
          <ParaglideMessage
            message={m.endpoint_not_serving_note}
            markup={{ b: ({ children }) => <span className="text-text">{children}</span> }}
          />
        </p>
      ) : null}
    </>
  );
};
